import React from 'react';
import DocumentCategoriesList from './DocumentCategoriesList';
import OverallStatsDisplay from './OverallStatsDisplay';
import styles from '../../../styles/DocumentManagement.module.css';
import { CompanyDocumentsProps } from '../../../types/DocumentManagement';

// This component will use DocumentCategoriesList which will automatically 
// use the CompanyDocumentHelpersContext when wrapped with CompanyDocumentHelpersProvider
// Props interface now imported from types file

const CompanyDocuments: React.FC<CompanyDocumentsProps> = React.memo(({
  overallStats,
  categoriesWithStats,
  categoriesMetadata,
  documentLoading,
  documentError,
  getSubcategoriesForCategory
}) => {
  return (
    <>
      <div className={styles.documentManagementHeader}>
        <h1 className={styles.documentManagementTitle}>Company Documents</h1>
        <p className={styles.documentManagementSubtitle}>Manage documents required for your agency's operations and compliance.</p>
      </div>

      <div className={styles.documentManagementSection}>
        <OverallStatsDisplay
          stats={overallStats}
          title="Company Documents Completion"
          showDetails={true}
        />
      </div>

      {/* Company Documents Section - no user selection needed */}
      <div className={styles.documentManagementSection}>
        <DocumentCategoriesList 
          categoriesWithStats={categoriesWithStats}
          categoriesMetadata={categoriesMetadata}
          overallStats={overallStats}
          loading={documentLoading}
          error={documentError}
          getSubcategoriesForCategory={getSubcategoriesForCategory}
          isCompanyMode={true}
        />
      </div>
    </>
  );
});

// Add display name for debugging
CompanyDocuments.displayName = 'CompanyDocuments';

export default CompanyDocuments;
